import React from 'react';
import styled from 'styled-components';
import { ActivityIndicator } from 'zarm';

const Template = styled.div`
  min-height: 555px;
  .img {
    width: 257px;
    height: 156px;
    margin: 80px auto 0;
    display: block;
  }
  .title {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
    margin: 30px 0 80px;
    text-align: center;
    padding: 0 50px;
  }
`;

const Loading = styled(ActivityIndicator)`
  position: fixed;
  top: 50%;
  left: 50%;
  div::before {
    background-color: #d0021b !important;
  }
`;

const list = {
  noPage: { img: 'https://habaocdn.fuhuibao.club/flb/common/1639018338593404@2x.png', text: '页面报错了', type: 'noPage' },
  noData: { img: 'https://habaocdn.fuhuibao.club/flb/common/1639018393225nodata@2x.png', text: '暂无数据', type: 'noData' },
  noSearch: { img: 'https://habaocdn.fuhuibao.club/flb/common/1639018403750nosearch@2x.png', text: '无搜索结果', type: 'noSearch' },
  waiting: { img: 'https://habaocdn.fuhuibao.club/flb/common/1640953679777123213.png', text: '敬请期待', type: 'waiting' },
  loading: { dom: <Loading type="spinner" />, type: 'loading' },
};

const Index = (props) => {
  const { type, text = '' } = props;
  const data = list[type];

  return (
    <Template>
      <>
        {type === 'loading' ? (
          <>{data.dom}</>
        ) : (
          <>
            <img className={'img'} src={data.img} alt={''} />
            <div className={'title'}>{text || data.text}</div>
          </>
        )}
      </>
    </Template>
  );
};

export default Index;
